import React from 'react'
import { useHistory } from 'react-router-dom'
import {
  IndexLayoutContent,
  IndexLayoutHeaderLink,
  routes,
} from '@sketch/modules-common'
import { Button } from '@sketch/components'
import {
  StyledExclamationMarkIcon,
  StyledPanel,
  PanelTitle,
  PanelBody,
  Description,
  PanelFooter,
  BottomText,
} from './SsoSignInErrorView.styles'
import {
  createLayoutPortal,
  workspaceSidebarLayoutSymbols,
} from '@sketch/utils'

const HeaderPortal = createLayoutPortal(workspaceSidebarLayoutSymbols.header)

export const SsoSignInErrorView = () => {
  const history = useHistory()

  const handleSignInAgain = () => {
    history.push(routes.SSO_SIGN_IN.create({}))
  }

  return (
    <IndexLayoutContent center>
      <HeaderPortal>
        <IndexLayoutHeaderLink />
      </HeaderPortal>
      <StyledPanel>
        <StyledExclamationMarkIcon width="64" height="64" />
        <PanelTitle>
          We couldn&apos;t sign you in to this&nbsp;Workspace.
        </PanelTitle>
        <PanelBody>
          <Description>
            Your session may have expired. This can happen if sign&#8209;in took
            too long.
          </Description>
        </PanelBody>
        <PanelFooter>
          <Button variant="primary" onClick={handleSignInAgain} fill>
            Sign In Again
          </Button>
        </PanelFooter>
        <BottomText textStyle="copy.tertiary.standard.D">
          If this error continues, contact your Workspace admin.
        </BottomText>
      </StyledPanel>
    </IndexLayoutContent>
  )
}
